import React from "react";

export const ComplainHelper = {
    Status: {
        Pending: 0,
        Open: 1,
        Responded: 2,
        Unsolved: 3,
        Solved: 4,
        Deleted: 5,
        Done: 10,
    },

    TranslateStatus: (status) => {
        console.log("status", status);
        switch (status) {
            case ComplainHelper.Status.Pending:
                return <span className="badge badge-warning">Pendente</span>;
            case ComplainHelper.Status.Open:
                return <span className="badge badge-info">Publicado</span>;
            case ComplainHelper.Status.Responded:
                return <span className="badge badge-info">Respondido</span>;
            case ComplainHelper.Status.Unsolved:
                return <span className="badge badge-warning">Não resolvido</span>;
            case ComplainHelper.Status.Solved:
                return <span className="badge badge-success">Resolvido</span>;
            case ComplainHelper.Status.Deleted:
                return <span className="badge badge-danger">Deletado</span>;
            case ComplainHelper.Status.Done:
                return <span className="badge badge-success">Concluído</span>;
            default:
                return <span className="badge badge-danger">Desconhecido</span>;
        }
    }
}